import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Auth as SupabaseAuth } from '@supabase/auth-ui-react';
import { ThemeSupa } from '@supabase/auth-ui-shared';
import { supabase } from '@/integrations/supabase/client';

const Auth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        navigate('/');
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 bg-card rounded-lg shadow-lg border border-border">
        <h1 className="text-2xl font-bold text-center mb-8 text-white">Добро пожаловать</h1>
        <SupabaseAuth 
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: 'hsl(var(--primary))',
                  brandAccent: 'hsl(var(--primary))',
                  inputBackground: 'hsl(var(--background))',
                  inputText: 'white',
                  inputPlaceholder: 'hsl(var(--muted-foreground))',
                  messageText: 'white',
                  anchorTextColor: 'hsl(var(--primary))',
                  dividerBackground: 'hsl(var(--border))',
                }
              }
            },
            className: {
              container: 'text-white',
              label: 'text-white',
              button: 'bg-primary hover:bg-primary/90 text-white',
              input: 'bg-background border-border text-white'
            }
          }}
          localization={{
            variables: {
              sign_in: {
                email_label: 'Email адрес',
                password_label: 'Пароль',
                email_input_placeholder: 'Ваш email',
                password_input_placeholder: 'Ваш пароль',
                button_label: 'Войти',
                loading_button_label: 'Вход...',
                social_provider_text: 'Войти через {{provider}}',
                link_text: 'Уже есть аккаунт? Войти'
              },
              sign_up: {
                email_label: 'Email адрес',
                password_label: 'Пароль',
                email_input_placeholder: 'Ваш email',
                password_input_placeholder: 'Ваш пароль',
                button_label: 'Регистрация',
                loading_button_label: 'Регистрация...',
                social_provider_text: 'Зарегистрироваться через {{provider}}',
                link_text: 'Нет аккаунта? Зарегистрироваться'
              },
              forgotten_password: {
                link_text: 'Забыли пароль?',
                email_label: 'Email адрес',
                password_label: 'Пароль',
                email_input_placeholder: 'Ваш email',
                button_label: 'Отправить инструкции',
                loading_button_label: 'Отправка инструкций...',
                confirmation_text: 'Проверьте ваш email для получения инструкций по сбросу пароля'
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default Auth;